<template>
  <v-container class="text-center pr-0 pl-0" fluid>


    <v-row>
        <v-col cols="12" xl="2" lg="4" md="6" sm="12" v-for="item in usuarios" :key="item.id"> 
          <v-card class="fill-height elevation-10" :disabled="dialogLoader">
            
            <v-card-title class="primary">
              {{item.fullName}}
              <v-spacer></v-spacer>
              <v-avatar
                size="50"
                class="elevation-5"
                v-if="item.profile && item.profile.media"
              >
                <img :src="item.profile.media.url">
              </v-avatar>
            </v-card-title>

            <v-card-text class="pt-4">
              
              <v-row>
                <v-col cols="12" class="title" v-if="item.profile && item.profile.frase">
                  "{{item.profile.frase}}"
                </v-col>
                <v-col cols="12" class="title" v-if="!item.plano && item.profile && item.profile.frase">
                  <v-divider class="mb-5"></v-divider>
                  Este aluno ainda não tem plano.
                </v-col>
                <v-col cols="12" class="subtitle" v-if="item.assinaturas && item.assinaturas.length > 0">
                  <v-divider class="mb-5"></v-divider>
                  
                  <v-text-field
                    label="Plano"
                    :value="item.assinaturas[0].plano.name"
                    dense
                    outlined
                    readonly
                  ></v-text-field>

                  <v-text-field
                    label="Vencimento"
                    :value="item.assinaturas[0].vencimento"
                    dense
                    outlined
                    readonly
                  ></v-text-field>

                  <v-text-field
                    :label="item.assinaturas[0].valorPago < 1 ? 'Valor pago (zerado porque foi criado manualmente)' : 'Valor Pago'"
                    prefix="R$"
                    :value="item.assinaturas[0].valorPago + ',00'"
                    dense
                    outlined
                    readonly
                  ></v-text-field>

                </v-col>
                <v-col cols="12" class="pt-0 pb-0 subtitle" v-if="item.assinaturas && item.assinaturas.length > 0">
                    <div v-if="item.cobrancaApp">Cobrado via App</div>
                    <div v-if="!item.cobrancaApp" class="">Não é cobrado via App</div>
                </v-col>


                <v-col cols="12" class="" v-if="item.profile && item.profile.frase">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" class="text-left body-1" v-if="item.profile">
                  <v-btn color="primary" width="100%" @click="selectedUser = item; showAssinaturaModal = true; currentPlano = selectedUser.plano;">
                    <span v-if="!item.plano">Incluir em um plano</span>
                    <span v-if="item.plano">Mudar Plano</span>
                    <v-icon right>mdi-card-account-details-outline</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" class="text-left body-1 pt-0" v-if="item.profile != null && item.profile.professor != null">
                  <v-btn color="primary" width="100%" @click="dialogProfessor = true; selectedUser = item;"> 
                    Treinador: {{item.profile.professor.fullName}}
                    <v-icon right>mdi-timer-outline</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" class="text-left body-1 pt-0" v-else-if="item.profile && !item.profile.professor">
                  <v-btn color="primary" width="100%" @click="dialogProfessor = true; selectedUser = item;">
                    Associar Treinador
                    <v-icon right>mdi-timer-outline</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" class="text-left body-1" v-else>
                  <span>Este aluno não criou o profile ainda. É necessário ele acessar o app e criar o profile.</span>
                </v-col>
                <v-col cols="12" class="text-left body-1 pt-0" v-if="item.profile != null && item.profile.professor != null">
                  <v-btn color="primary" width="100%">
                    Histórico
                    <v-icon right>mdi-calendar</v-icon>
                  </v-btn>
                </v-col>
                <!-- <v-col cols="12" class="text-left body-1 pt-0" v-if="item.profile != null && item.profile.professor != null">
                  <v-btn color="primary" width="100%" @click="dialogAgendarTreino = true; selectedUser = item;" disabled>
                    Programar Treinos
                    <v-icon right>mdi-clipboard-list-outline</v-icon>
                  </v-btn>
                </v-col> -->
              </v-row>

            </v-card-text>

          </v-card>
        </v-col>
      </v-row>

    <aluno-assinatura-modal :item="selectedUser" :planoAtual="currentPlano" :showDialog="showAssinaturaModal" @close-dialog-assinatura="closeDialogAssinatura" />

    

    <div class="text-center">
      <v-dialog
        v-model="dialogProfile"
        width="500"
      >

        <v-card v-if="selectedUser != null && selectedUser.profile != null">
          <v-card-title class="subtitle grey lighten-2 pr-2">
            Profile de {{selectedUser.fullName}}
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogProfile = false; selectUser = null;">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pt-5" v-if="selectedUser.enabled">
            
            <v-row v-if="selectedUser.profile.media != null" class="text-center">
              <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="">
                <v-avatar class="" size="200">
                  <img :src="selectedUser.profile.media.url">
                </v-avatar>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="text-center">
              <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="">
                {{selectedUser.profile.frase}}
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="text-center" v-if="selectedUser.profile.professor != null">
              <v-col cols="12" xl="12" lg="12" md="12" sm="12" class="">
                Coach: {{selectedUser.profile.professor.fullName}}
              </v-col>
            </v-row>


          </v-card-text>

          <v-divider></v-divider>

         
        </v-card>
      </v-dialog>
    </div>

    <div class="text-center">
      <v-dialog v-model="dialogProfessor" width="400">
        <v-card v-if="selectedUser != null && selectedUser.profile != null"> 
          <v-card-title class="primary">
            Selecione um Treinador
          </v-card-title>
          <v-card-text class="pt-5">
            <v-select
              v-model="selectedUser.profile.professor"
              :items="professorList"
              item-text="fullName"
              label="Meu Treinador"
              return-object
              outlined
              dense
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-btn color="primary" text @click="dialogProfessor = false;" :disabled="dialogLoader">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="salvarProfessor()" :disabled="dialogLoader || selectedUser.profile.professor == null">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>





    <!-- loader -->
    <div class="text-center">
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-5">
            Carregando...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

  </v-container>
</template>

<script>

import HOST from '../ws'
import SnackBar from "../snackbar";
import Esportes from "../fake-data/Esportes";
import TreinoData from "../fake-data/TreinoData";
import AlunoAssinaturaModal from '../components/AlunoAssinaturaModal.vue';

export default {
  components: { AlunoAssinaturaModal },

  props: {
    source: String
  },
  data: vm => ({

    myHost : HOST.HOST,

    dialogLoader : false,
    showAssinaturaModal : false,

    filter : '',

    nophoto : require('../assets/images/nophoto.gif'),

    //dialogs:
    dialogEditUser : false,
    dialogDisable : false,
    dialogProfile : false,
    dialogProfessor : false,
    dialogAgendarTreino : false,

    esportesList: Esportes.ESPORTES,
    tipoTreinoList: TreinoData.TREINODATA,

    //objetos do datepicker data do treino:
    dateTreino: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    menu2: false,
    today : new Date().toISOString().substr(0, 10),

    //objetos do datepicker de repetição:
    dateLimite: new Date().toISOString().substr(0, 10),

    //objetos dos campos do formulário de passar treino:
    tempo : null,

    //dialog de inserir serie:
    dialogSerie : false,
    descanso : '',
    observacoesSerie : '',
    seriesDoTreino : [],

    //dialogs de detalhe:
    dialog: false,
    dialogComment: false,
    dialogRepeat: false,
    panelStatus: 1,
    loadedComment: "",
    volumeSerie : null,    

    selectedAluno: [],
    selectedAlunoTreinosFeitos : [],
    selectedEsporte: null,
    setDefaultEsporte: false,
    selectedTipoTreino: null,
    radiosRepetir : null,

    repeticoes : 1,
    repeticoesList : [],
    frequencia : 10,
    frequenciaList : [],
    metrosNatacaoList : [],
    metrosNatacao : 100,

    //para calculo do pace:
    paceMinutos : null,
    paceKilometros : null,
    calculatedPace : null,

    //repeticoes:
    repetir : null,
    repetirData : null,

    professorList : [],

    
    //usuarios:
    usuarios : [],

    //usuario selecionado:
    selectedUser : null,
    currentPlano : null,

    
  }),

  computed: {
    computedDateFormatted () {
      return this.formatDate(this.dateTreino)
    },
    computedDateLimiteFormatted () {
      return this.formatDate(this.dateLimite)
    },
  },

  watch: {

    dateTreino () {
      this.dateFormatted = this.formatDate(this.dateTreino)
    },
    
    dateLimite () {
      this.dateLimiteFormatted = this.formatDate(this.dateLimite)
    },

    selectedTipoTreino(){
      this.paceMinutos = null;
      this.paceKilometros = null;
      this.metrosNatacao = null;
      this.tempo = null;
      this.descanso = null;
      this.repeticoes = null;
      this.observacoesSerie = null;
      this.volumeSerie = null;
    },
    selectedEsporte(){
      this.selectedTipoTreino = null;
      this.radiosRepetir = null;
    }
  },

  created (){
    //adicionando itens ao array da combo:
    var i; 
    for (i = 1; i <= 60; i++) {
      this.repeticoesList.push(i);
    }
    for (i = 1; i <= 10; i++) {
      this.frequenciaList.push(i*5);
    }
    for (i = 1; i <= 20; i++) {
      this.metrosNatacaoList.push(i*5);
    }
    for (i = 1; i <= 120; i++) {
      this.metrosNatacaoList.push(i*50);
    }
    
  },

  mounted() {
    
    this.selectedUser = null;
    this.reloadUserList();
    this.reloadProfessorList();
  },

  


  methods : {

    closeDialogAssinatura(){
      //this.$emit('close-dialog', false);
      this.showAssinaturaModal = false;
      this.selectedUser = null;
      this.reloadUserList();
    },


    reloadUserList(){

      this.dialogLoader = true;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
      .post(this.myHost + '/user/allalunos', {}, config)
      .then(response => {
        this.usuarios = response.data;
        this.dialogLoader = false;
        //console.log(JSON.stringify(this.usuarios));
      })
      .catch((error) => {
         console.log(error.message);
         this.dialogLoader = false;
         this.$store.commit('logout');
         this.$router.push("login");
      });
    },

    deleteUser(val){
      this.selectedUser = val;
      this.dialogEditUser = true;
    },
    loadToDisable(val){
      this.selectedUser = val;
      this.dialogDisable = true;
    },
    loadProfile(val){
      this.selectedUser = val;
      this.dialogProfile = true;
    },

    changeStatus(){

      if(this.selectedUser != null){

        this.axios({
          method: 'post',
          url : this.myHost + '/user/changestatus', 
          headers: {
              'Content-Type' : 'application/json',
              Authorization: `Bearer ${this.$store.state.currentToken}`},           
              data : JSON.stringify(this.selectedUser)
        })
        .then(response => {
          console.log(response.data.fullName);
          this.reloadUserList();
          this.dialogDisable = false;
        })
        .catch((error) => {
          console.log(error.message);
          this.$store.commit('logout');
          this.$router.push("login");
        });
        
      }
    },

    reloadProfessorList(){
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
      .post(this.myHost + '/user/allprofessoresativos', {}, config)
      .then(response => {
        this.professorList = response.data;
      })
      .catch((error) => {
         console.log(error.message);
         this.$store.commit('logout');
         this.$router.push("login");
      });
    },

    salvarProfessor(){

      let formData = new FormData();
      formData.append("professorId", this.selectedUser.profile.professor.id);
      formData.append("alunoId", this.selectedUser.id);

      this.dialogLoader = true;
      this.axios
        .post(this.myHost + "/profilecontroller/updateprofessor", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${this.$store.state.currentToken}`
          }
        }).then(response => {

          console.log('salvou professor : ' + response.status);

          if(response.status == 200){
            
            console.log('atualizando usuario : ' + response.status);
            this.dialogLoader = false;
            this.dialogProfessor = false;
            this.selectedUser = null;
            SnackBar.snackText = "Professor atualizado";
            SnackBar.showSnack = true;

            this.reloadUserList();
          }
      })
      .catch((error) => {
        console.log(error.message);
        SnackBar.snackText = "Ops... ocorreu um erro. Tente novamente, por favor.";
        SnackBar.showSnack = true;
      });

    },

    //métodos do date picker:
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    calculatePace(){
    //   paceMinutos : null,
    // paceKilometros : null,
    // calculatedPace : null,
    // metrosNatacao : 100,

      if(this.selectedTipoTreino != null &&  this.selectedTipoTreino.nome == 'Pace'){
        if(this.paceMinutos != null && this.paceMinutos != ''){
          
          if(this.paceKilometros != null && this.paceKilometros != ''){

             switch (this.selectedEsporte.nome){
               case 'Ciclismo' :
                this.calculatedPace = (this.paceKilometros/(this.paceMinutos/60)).toFixed(2);
                break;
              case 'Corrida' :
                this.calculatedPace = (this.paceMinutos/(this.paceKilometros)).toFixed(2);
                break;
             }
          }else if(this.metrosNatacao != null && this.metrosNatacao != ''){

             switch (this.selectedEsporte.nome){
              case 'Natação' :
                this.calculatedPace = (this.paceMinutos/(this.metrosNatacao/100)).toFixed(2);
                break;
             }
          }
        }
      }
    },
    removerSerie(val) {
      this.seriesDoTreino.splice(val,1);
    },
    incluirSerie(){

      let novaSerie = {
        id : (this.seriesDoTreino.length + 1),
        esporte : this.selectedEsporte.nome,
        tipoTreino : this.selectedTipoTreino.nome,
        paceMinutos : this.paceMinutos,
        metrosNatacao : this.metrosNatacao,
        tempo : this.tempo,
        descanso : this.descanso,
        repeticoes : this.repeticoes,
        calculatedPace : this.calculatedPace,
        medida : this.selectedEsporte.medida,
        volume : this.volumeSerie,
        observacoes : this.observacoesSerie,

      }

      this.seriesDoTreino.push(novaSerie);
      this.dialogSerie = false;
      this.selectedTipoTreino = null;

      //snackbar sucesso:
      this.snackText = 'Série adicionada ao treino.';
      this.snackbar = true;
    },
    salvarTreino(){

      //console.log(JSON.stringify(this.seriesDoTreino));
      this.dialogLoader = true;

      //montando o objeto:
      let newTreino = {
        professor : this.$store.getters.userLogged,
        aluno : this.selectedAluno,
        dataTreino : this.dateFormatted,
        esporte : this.selectedEsporte.nome,
        series : this.seriesDoTreino,
        repetir : this.radiosRepetir,
        dateLimite : this.computedDateLimiteFormatted,
      }
      //console.log(JSON.stringify(newTreino));  
      this.axios({
        method: 'post',
        url : this.myHost + '/treino/save', 
        headers: {
            'Content-Type' : 'application/json',
            Authorization: `Bearer ${this.$store.state.currentToken}`},
            data : JSON.stringify(newTreino)
      }).then((response) => {

        console.log('treino salvo : ' + response.status);  
        this.dialogLoader = false;
        this.selectedEsporte = null;
        this.snackText = 'Treino agendado para o aluno!';
        this.snackbar = true;
        this.seriesDoTreino = [];
        
      });
    },
    clickTrash(treino){
      this.dialogLoader = true;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
        .post(this.myHost + "/treino/deletetreino/" + treino.id, {}, config)
        .then(response => {
          console.log('click trash : ' + response.status);  

          //carrega os treinos passados do aluno:
          //carrega os treinos:
          const config = {
            headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
          };
          this.axios
          .post(this.myHost + "/treino/meusultimostreinos/" + this.selectedAluno.id, {}, config)
          .then(response => {
            this.selectedAlunoTreinosFeitos = response.data;
            this.dialogLoader = false;
            //console.log(this.treinoList);
          })
          .catch(error => {
            console.log(error.message);
            this.dialogLoader = false;
            this.$store.commit("logout");
            this.$router.push("/");
          });
      })
      .catch(error => {
        console.log(error.message);
        this.dialogLoader = false;
        this.$store.commit("logout");
        this.$router.push("/");
       });
    },

  }
};
</script>
